<nz-card>
  <div class="search-bar" style="display:flex; gap:8px; align-items:center; margin-bottom:16px;">

    <nz-range-picker
      [(ngModel)]="dateRange"
      (ngModelChange)="onDateRangeChange()"
      nzFormat="yyyy-MM-dd"
      nzPlaceHolder="Select date range"
      style="width: 320px;"
    ></nz-range-picker>

    <input
      nz-input
      placeholder="Username"
      [(ngModel)]="searchCriteria.username"
      style="width: 200px;"
    />

    <nz-select
      [(ngModel)]="searchCriteria.operation"
      nzAllowClear
      nzPlaceHolder="Operation"
      style="width: 160px;"
    >
      <nz-option nzValue="INSERT" nzLabel="INSERT"></nz-option>
      <nz-option nzValue="UPDATE" nzLabel="UPDATE"></nz-option>
      <nz-option nzValue="DELETE" nzLabel="DELETE"></nz-option>
    </nz-select>

    <button nz-button nzType="primary" (click)="loadTableData()">Search</button>
    <button nz-button (click)="onRefresh()">Reset</button>
  </div>
</nz-card>

<nz-card>
  <div class="ng-Header">
    <i nz-icon nzType="unordered-list"></i> Authentication Activity Log
  </div>

  <nz-table
    [nzData]="logsList"
    [nzTotal]="total"
    [(nzPageIndex)]="searchCriteria.page"
    [(nzPageSize)]="searchCriteria.size"
    nzShowSizeChanger
    nzBordered
    [nzFrontPagination]="false"
    (nzPageIndexChange)="onPageIndexChange($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"
    [nzShowPagination]="true"
    [nzShowTotal]="totalRowRangeTemplate"
  >
    <ng-template #totalRowRangeTemplate let-total>
      Showing {{ getStartIndex() }}-{{ getEndIndex() }} of {{ total }} items
    </ng-template>

    <thead>
    <tr>
      <th>ID</th>
      <th>Information Type</th>
      <th>Description</th>
      <th>Operation</th>
      <th>Changed At</th>
      <th>User Name</th>
      <th>Designation</th>
      <th>Email</th>
      <th>IP</th>
      <th style="text-align:center">Action</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let log of logsList">
      <td>{{ log.logId }}</td>
      <td>{{ log.module }}</td>
      <td>{{ log.description }}</td>
      <td>{{ log.operation }}</td>
      <td>{{ log.changedAt | date:'dd-MM-yyyy HH:mm:ss' }}</td>
      <td>{{ log.userName || 'N/A' }}</td>
      <td>{{ log.designation || 'N/A' }}</td>
      <td>{{ log.email || 'N/A' }}</td>
      <td>{{ clientIp }}</td>
      <td style="text-align:center">
        <button nz-button nzType="link" (click)="openComparisonModal(log)">
          <i nz-icon nzType="eye"></i>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
</nz-card>

<nz-modal
  [(nzVisible)]="isPreviewVisible"
  [nzTitle]="modalTitle"
  (nzOnCancel)="handleCancel()"
  [nzFooter]="null"
  [nzWidth]="'80vw'"
  [nzBodyStyle]="{
    'max-height': '70vh',
    'overflow': 'auto',
    'white-space': 'pre-wrap',
    'word-break': 'break-word'
  }">

  <!-- INSERT: two-column diff -->
  <ng-container *ngIf="isInsert">
    <table nz-table class="diff-table">
      <thead>
      <tr>
        <th>Field</th>
        <th>New Value</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of detailList">
        <td>{{ row.key }}</td>
        <td>
          <ng-container *ngIf="row.key === 'updated_at' || row.key === 'created_at' ; else plainNew">
            {{ row.newVal | date:'dd-MM-yyyy HH:mm:ss' }}
          </ng-container>
          <ng-template #plainNew>
            {{ row.newVal }}
          </ng-template>
        </td>
      </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- UPDATE: full diff with old/new and highlighting -->
  <ng-container *ngIf="isUpdate">
    <table nz-table class="diff-table">
      <thead>
      <tr>
        <th>Field</th>
        <th>Old Value</th>
        <th>New Value</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of detailList" [ngClass]="{'changed-row': row.changed}">
        <td>{{ row.key }}</td>
        <td>
          <ng-container *ngIf="row.key === 'updated_at' || row.key === 'created_at'; else plainOld">
            {{ row.oldVal | date:'dd-MM-yyyy HH:mm:ss' }}
          </ng-container>
          <ng-template #plainOld>
            {{ row.oldVal }}
          </ng-template>
        </td>
        <td>
          <ng-container *ngIf="row.key === 'updated_at' || row.key === 'created_at'; else plainNew">
            {{ row.newVal | date:'dd-MM-yyyy HH:mm:ss' }}
          </ng-container>
          <ng-template #plainNew>
            {{ row.newVal }}
          </ng-template>
        </td>
      </tr>
      </tbody>
    </table>
  </ng-container>

  <ng-container *ngIf="isDelete">
    <table nz-table class="kv-table">
      <thead>
      <tr>
        <th>Field</th>
        <th>Value</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of kvList">
        <td>{{ row.key }}</td>
        <td>{{ row.value }}</td>
      </tr>
      </tbody>
    </table>
  </ng-container>

  <div *nzModalFooter style="text-align: right; margin-top:16px;">
    <button nz-button nzType="primary" (click)="handleCancel()">Close</button>
  </div>
</nz-modal>

